import React, { useState } from 'react';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import BrokerFeesModal from './BrokerFeesModal';

/**
 * Permanent banner reminding users that TRADEX AI computations are gross of
 * broker fees. Sits under the Calculator results. Click opens BrokerFeesModal.
 */
export default function BrokerFeesBanner({ className = '' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`w-full text-left flex items-start gap-3 p-3 rounded-lg border border-amber-500/25 bg-amber-500/5 hover:bg-amber-500/10 transition-colors ${className}`}
        data-testid="broker-fees-banner"
      >
        <AlertTriangle className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1 text-xs sm:text-sm">
          <span className="text-foreground">
            <strong>Les frais broker peuvent réduire ces montants de 0,15 % à 3 %+</strong> selon le broker (spread, commission, funding, overnight financing) et la durée de la position.
          </span>
          <span className="ml-1 text-amber-400 font-medium inline-flex items-center gap-0.5">
            En savoir plus <ChevronRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </button>
      {open && <BrokerFeesModal onClose={() => setOpen(false)} />}
    </>
  );
}
